import React from 'react'

const RegistrationDraftsContentHeader = () => (
    <>
        <p>Registration Drafts contains the saved information from incomplete work registrations.</p>
        <p>PLEASE NOTE: A draft can only be saved once.</p>
    </>
)

export default RegistrationDraftsContentHeader
